 <i class="material-icons check" *ngIf="value">check</i>
 <i class="material-icons close" *ngIf="!value">close</i>
